import { Button, Divider, ModalBody, ModalFooter, Stack, Text, useToast } from "@chakra-ui/react";
import { Alert, Form, Icon, Modal } from "components";
import { API } from "config";
import { Mask } from "config";
import { useDistributorsList } from "hooks";
import useAllDistributors from "hooks/useAllDistributors";
import moment from "moment";
import { useState } from "react";

export default function DistributorPurchasesSold({ ...props }){

    const toast = useToast()
    const [ loading, setLoading ] = useState()
    const [ errors, setErrors ] = useState()
    const [ distributor_id, setDistributor ] = useState()
    const distributors = useAllDistributors()
    const [ init, setInit ] = useState(moment().startOf('month').format('DD/MM/Y'))
    const [ end, setEnd ] = useState(moment().endOf('month').format('DD/MM/Y'))

    const handleSubmit = async () => {
        setLoading(true)

        try{
            const callback = await API.get(`/tools/distributors/purchases_x_sales_report?init=${init}&end=${end}&distributor_id=${distributor_id}`)
            toast({ title: 'Relatório gerado', description: 'Download em andamento...', status: 'success'})
            window.open(callback?.data?.download_url)
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toast({ title: 'Não foi possível gerar o relatório agora. Tente novamente.', description: err?.response?.data?.message, status: 'warning'})
        }

        setLoading(false)
    }

     return(
    <Modal title="Produtos comprados x vendidos por período." {...props}>
        <ModalBody>
            <Stack spacing={4}>
                <Text fontSize="sm">O relatório será gerado para todos os pedidos aprovados no intervalo de datas definido abaixo. Será gerado um arquivo .csv e o download se iniciará em seguida.</Text>
            
                <Divider />

                <Form.Form onSubmit={handleSubmit}>

                    <Form.Select
                        label="Selecione um núcleo:"
                        options={distributors.data?.map(item => ({ label: item.name, value: item.id }))}
                        onChange={e => setDistributor(e.target.value)}
                    />

                    <Form.Text
                        required
                        label="Data de início:"
                        name="init"
                        value={init}
                        onChange={e => setInit(Mask.date(e.target.value))}
                        isDisabled={loading}
                        error={errors?.init}
                        placeholder="Ex.: 01/01/2025"
                    />

                    <Form.Text
                        required
                        label="Data final:"
                        name="end"
                        value={end}
                        onChange={e => setEnd(Mask.date(e.target.value))}
                        isDisabled={loading}
                        error={errors?.end}
                        placeholder="Ex.: 31/05/2025"
                    />

                    <Alert>É recomendável que importe este arquivo no <a href="">Planilhas do Google</a> para melhor visualização.</Alert>
                </Form.Form>
            </Stack>
        </ModalBody>

        <ModalFooter>
            <Button w="100%" colorScheme="orange" onClick={handleSubmit} isLoading={loading} loadingText="Gerando relatório..." leftIcon={<Icon name="download" />}>Gerar relatório e fazer download</Button>
        </ModalFooter>
    </Modal>
    )
}